var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurniture8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.88,
    height: 44.682,
    viewBox: "0 0 52.88 44.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7747",
    "data-name": "Grupo 7747",
    transform: "translate(-52 -51)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2105",
    "data-name": "Ret\\xE2ngulo 2105",
    width: 24,
    height: 12,
    rx: 2,
    transform: "translate(78 51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_26",
    "data-name": "Uni\\xE3o 26",
    d: "M26.44,43.988H2.891a.858.858,0,0,1-.858-.857V22.5a2.194,2.194,0,0,1-1.385-.612,2.2,2.2,0,0,1,1.558-3.763H34.656V16.727h-7.23a1.677,1.677,0,0,1-1.675-1.675V1.675A1.678,1.678,0,0,1,27.426,0H49.172a1.667,1.667,0,0,1,1.181.491l0,0,0,0a1.669,1.669,0,0,1,.491,1.184V15.052a1.67,1.67,0,0,1-.491,1.184c-.021.021-.043.041-.066.059a1.667,1.667,0,0,1-1.118.432H41.943v1.394h8.732a2.19,2.19,0,0,1,.173,4.375V43.13a.857.857,0,0,1-.857.857ZM27.3,32.4v9.87H49.132V22.532H27.3Zm-23.55,9.87H25.582V33.26H3.749Zm0-10.728H25.582V22.532H3.749ZM1.86,19.981a.489.489,0,0,0,.345.835h48.47a.489.489,0,0,0,0-.979H2.205A.488.488,0,0,0,1.86,19.981Zm34.512-1.86h3.854V16.727H36.372Zm-8.906-3.109H49.132V13.827H27.467Zm0-2.9H49.132V1.715H27.467Zm-9.385,26.53-6.84-.042a.854.854,0,1,1,.007-1.708l6.84.041a.855.855,0,0,1,0,1.709Zm0-10.623-6.84-.042a.854.854,0,0,1,.007-1.709l6.84.042a.854.854,0,0,1,0,1.709Z",
    transform: "translate(52 51.694)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture8);
export default __webpack_public_path__ + "static/media/furniture-8.0d8da891a6164958162be44d7355ec2a.svg";
export { ForwardRef as ReactComponent };